import * as React from "react";
import { FileTypeResult, FileTypeParser, Detector } from "file-type";

const CUSTOM_DETECTORS: Detector[] = [];

export const useBufferFileType = (buffer: Uint8Array | ArrayBuffer) => {
  const [fileType, setFileType] = React.useState<FileTypeResult>();
  React.useEffect(() => {
    const abortController = new AbortController();
    const parser = new FileTypeParser({
      customDetectors: CUSTOM_DETECTORS,
      signal: abortController.signal,
    });
    parser.fromBuffer(buffer).then((result) => {
      setFileType(result);
    });
    () => {
      abortController.abort();
    };
  }, [buffer]);
  return fileType;
};
